import { useQuery } from "@tanstack/react-query";
import { useAuditTrailService } from "../apis/auditTrail/useAuditTrailService";
import {
  TAuditTrailResponse,
  TAuditTrailFilter,
} from "../apis/auditTrail/auditTrail.interfaces";

export const useAuditTrailHook = (filters?: TAuditTrailFilter) => {
  const { getAuditTrail } = useAuditTrailService();

  return useQuery<TAuditTrailResponse>({
    queryKey: ["auditTrail", filters],
    queryFn: () => getAuditTrail(filters),
    staleTime: 1 * 60 * 1000, // 1 minute
  });
};
